// Angular
import { Directive, ElementRef, inject } from '@angular/core';
import { AfterViewInit } from '@angular/core';

@Directive({
    selector: '[autoFocusMenuInput]'
})
export class AutoFocusMenuInputDirective implements AfterViewInit {

    // Inject
    private readonly hostElement = inject(ElementRef<HTMLElement>);

    ngAfterViewInit() {
        queueMicrotask(() => {
            const el = this.hostElement.nativeElement;
            el.focus();
            el.select();
        });
    }
}